import {Component, Inject, OnInit} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {get} from 'lodash-es';


@Component({
    selector: 'app-edit-step',
    templateUrl: './edit-step.component.html',
    standalone: false
})
export class EditStepComponent implements OnInit {
    public form: UntypedFormGroup;

    constructor(public dialogRef: MatDialogRef<EditStepComponent>,
                @Inject(MAT_DIALOG_DATA) public data: { instructionKey: string, title: string, instruction: string } ) {
    }

    ngOnInit(): void {
        this.form = this.createForm();
    }

    public createForm(): UntypedFormGroup {
        const config = {
            title: [get(this.data, 'title', ''), Validators.required],
            instruction: [get(this.data, 'instruction', ''), Validators.required],
        };

        return new UntypedFormBuilder().group(config);
    }

    validate(): void {
        this.dialogRef.close(this.form.value);
    }
}